import React from 'react';
import { motion } from 'framer-motion';
interface PageTransitionProps {
  children: React.ReactNode;
  className?: string;
}
export function PageTransition({
  children,
  className = ''
}: PageTransitionProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 24
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -24
  }} transition={{
    duration: 0.45,
    ease: [0.16, 1, 0.3, 1]
  }} className={`w-full min-h-screen flex flex-col ${className}`} data-id="element-101">
      {children}
    </motion.div>;
}